// extracted by mini-css-extract-plugin
export var container = "NewsletterPopup-module--container--3o_JC";
export var hiddenPopup = "NewsletterPopup-module--hiddenPopup--EqCuh";
export var header = "NewsletterPopup-module--header--u0r_r";
export var collapseIcon = "NewsletterPopup-module--collapseIcon--3wLnI";
export var collapsedIcon = "NewsletterPopup-module--collapsedIcon--2qk-F";
export var collapsedContent = "NewsletterPopup-module--collapsedContent--3q2R2";
export var uncollapsedContent = "NewsletterPopup-module--uncollapsedContent--3ZIj7";
export var content = "NewsletterPopup-module--content--2BgK8";